import { getNodeConfig } from '../../../../api/workflows-steps/formSchema.tsx';
import { WorkflowNodeType } from '../../../../api/model.ts';
import { Draggable } from '@hello-pangea/dnd';
import { DraggableListItem, NodeRowCard } from '../Form.styles.tsx';
import { DragIndicator } from '@mui/icons-material';

type NodeRowProps = {
  id: string;
  index: number;
  name: string;
  type: WorkflowNodeType;
  disabled?: boolean;
};

const PythonFunctionNodeDraggableRow = ({ id, index, name, type, disabled }: NodeRowProps) => {
  const { color, icon } = getNodeConfig(type)!;
  return (
    <Draggable key={id} draggableId={id} index={index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={{
            marginBottom: '8px',
            ...provided.draggableProps.style,
          }}
        >
          <DraggableListItem
            className="grid grid-cols-1 gap-4 md:grid-cols-12 items-center"
            isDragging={snapshot.isDragging}
            color={color}
          >
            <NodeRowCard className="col-span-1" color={color}>
              {icon}
            </NodeRowCard>
            <span className="col-span-4 text-center font-bold">input_df_{index + 1}</span>

            <div className="col-span-6 text-center">{name}</div>
            <div className="col-span-1 flex justify-end">{!disabled && <DragIndicator />}</div>
          </DraggableListItem>
        </div>
      )}
    </Draggable>
  );
};

export default PythonFunctionNodeDraggableRow;
